import store from "@/store";
import Review from '@/components/game/scenes/Review';
import TravelTracker from '@/components/game/sidebar/TravelTracker';

export default [
	{
		path: 'review',
		name: "REVIEW",
		components: {
			gameSpace: Review,
			sidebar: TravelTracker,
		},
		props: {
			sidebar: () => ({
				totalStops: store.getters["game/chapters/totalCount"],
				currentStop: store.state.game.chapters.index,
			}),
		},
		async beforeEnter(to, from, next) {
			await store.dispatch("game/budgets/reset");
			await store.dispatch("game/balance/calculate");
			const maybeRedirect = store.getters["game/scores/zeroScore"] ? { path: '/game/complete' } : {};

			next(maybeRedirect);
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/review.routes.js